export default __webpack_public_path__ + "static/media/matic.ea31286e.svg";